import(/* webpackChunkName: "login-form-controller" */ './login-form-controller');
import(/* webpackChunkName: "welcome-modal" */ './welcome-modal');

if (document.querySelector('login-error-message')) {
  import(/* webpackChunkName: "login-error-message" */ './login-error-message');
}

if (document.querySelector('form.potential-login-email-form')) {
  import(/* webpackChunkName: "potential-login-email-form" */ './potential-login-email-form')
    .then((module) => module.default());
}

if (document.querySelector('sg-a-context')) {
  import(/* webpackChunkName: "sg-a-context" */ './sg-a-context')
    .catch(error => {
      console.error('Error loading auth context:', error);
    });
}

if (document.querySelector('sg-carousel')) {
  import(/* webpackChunkName: "sg-carousel" */ './sg-carousel');
  import(/* webpackChunkName: "sg-carousel-card" */ './sg-carousel-card');
}

if (document.querySelector('edit-profile-form-controller')) {
  import(/* webpackChunkName: "edit-profile-form-controller" */ './edit-profile-form-controller');
}

if (document.querySelector('questions-modal')) {
  import(/* webpackChunkName: "questions-modal" */ './questions-modal');
}

// Show the renew alert modal
if (document.querySelector("#renew-alert-placeholder")) {
  const placeholder = document.getElementById('renew-alert-placeholder') as HTMLElement;
  const showAlert = placeholder.getAttribute('data-show-renew-alert') === 'true';
  const renewAlert = localStorage.getItem('sn-renew-alert');
  const oneDayInMs = 24 * 60 * 60 * 1000; // 24 hours - this guarantees that the popup will be shown only once in this day

   if (showAlert && (!renewAlert || (Date.now() - parseInt(renewAlert, 10)) > oneDayInMs)) {
    import(/* webpackChunkName: "premium-renew-alerts-modal" */ './premium-renew-alerts-modal').then(() => {
      const modal = document.createElement('premium-renew-alerts-modal');
      placeholder.appendChild(modal);
    });
  }
}